"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDots = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DOT_COUNT = 3; // the same as $loading-dots-count in loadingDots.scsss
/**
 * @internal
 */
exports.LoadingDots = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("gd-loading-dots", className) }, range_1.default(1, DOT_COUNT + 1).map(function (index) { return (react_1.default.createElement("div", { key: index, className: "gd-loading-dots-" + index })); })));
};
//# sourceMappingURL=LoadingDots.js.map